import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow, useModalWindow } from '@hooks/useModalWindow';
import { IAtividade } from '@model/Atividade';
import { useAtividadeService } from '@services/AtividadeService';
import React from 'react';
import { AtividadeDiferencaModal } from './AtividadeDiferencaModal';
import { AtividadeTable } from './AtividadeTable';

export type AtividadeModalProps = {
    modal: IModalWindow,
    entidade: string
    chaves: object
}

export function AtividadeModal ({ modal, entidade, chaves }: AtividadeModalProps) {
    const chavesString = React.useMemo(() => JSON.stringify(chaves), [chaves]);

    const loading = useLoading();
    const message = useMessage();
    const data = useData<IAtividade>();

    const diferencaModal = useModalWindow();

    const atividadeService = useAtividadeService();

    const handleEnter = React.useCallback(() => {
        if (chavesString && !loading.isLoading) {
            loading.start();
            atividadeService.load(entidade, chavesString)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [atividadeService, chavesString, data.handleDataResponse, entidade, loading, message.showException]);

    return (
        <React.Fragment>
            <ModalWindow
                modal={modal}
                disabled={loading.isLoading}
                size="md"
                TransitionProps={{
                    onEnter: handleEnter
                }}
            >
                <ModalWindowTitle
                    title={`Atividade de ${entidade} de ${chavesString}`}
                />
                
                <ModalWindowContent>
                    <AtividadeTable 
                        data={data}
                        diferencaModal={diferencaModal}
                    />
                </ModalWindowContent>
            </ModalWindow>

            {
                data.focusedRow !== undefined && (
                    <AtividadeDiferencaModal 
                        atividade={data.focusedRow}
                        modal={diferencaModal}
                    />
                )
            }
        </React.Fragment>
    )
}